import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-setting-rolling-form',
  templateUrl: './setting-rolling-form.component.html',
  styleUrls: ['./setting-rolling-form.component.scss']
})
export class SettingRollingFormComponent {
  @ViewChild('f') f : NgForm

  public data:any = {status: 1};
  public providers:any = [];
  public categories:any = [];
  public rolling_uuid:any;

  constructor(private http: HttpService, private route: ActivatedRoute) { 
    this.getGames();
    this.initGamesCategory();
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['uuid']));

    uuid.subscribe(val => {
      if(val) {
        this.init(val)
        this.rolling_uuid = val;
      }
    })

  }

  async init(val:any) {
    this.data = await this.http.post("/admin/setting/rolling/get", {uuid: val});
  }

  async getGames() {
    this.providers = await this.http.post("/admin/setting/seemless-game/get");
  }

  async initGamesCategory() {
    this.categories = await this.http.post("/admin/app/game/category/init");
  }


  async submit(stay = false) {
    let rtn:any = await this.http.post('/admin/setting/rolling/update', this.data);

    if(stay) {
      return;
    }

    if(rtn.message && !rtn.status) {
      this.http.notify(rtn.message);
    }

    if (rtn.uuid) {
      this.http.navigate(['/lo',this.http.getStaticSelectedCompany(),'setting-rolling', 'form', rtn.uuid])
      return;
    }
    
    await this.f.resetForm({status: 1});
  }


}

